import { atom } from "recoil";

export const IsTokenState = atom<string>({
	key: 'is-token-state-key',
	default: '',
});